<template>
    <el-form ref="form" label-position="top" v-loading="getScreenSize < 2 && !delayedLoading[3]"  element-loading-text="Loading...">
        <el-row :gutter="25" v-if="getScreenSize > 1 || delayedLoading[1]">
            <el-col :lg="24">
                <el-form-item class="el-form-item-full" :label="$l('settings/weather/Weather')">
                    <el-select v-model="getSettingsWeather.device" :placeholder="$l('common/select')">
                        <el-option :label="$l('settings/weather/NoWeather')" value="NaN"></el-option>
                        <el-option :label="$l('settings/weather/reinhardt')" value="5MV"></el-option>
                        <el-option :label="$l('settings/weather/reinhardtRain')" value="5MVRain"></el-option>
                        <el-option :label="$l('settings/weather/thiesClima')" value="THIES"></el-option>
                        <el-option :label="$l('settings/weather/vaisala')" value="WXT520"></el-option>
                        <el-option :label="$l('settings/weather/kw360')" value="KW360"></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
        </el-row>
        <el-form-item class="el-form-item-full pixel" v-if="getScreenSize > 1 || delayedLoading[2]">
            <el-button :loading="setDeviceLoading" @click="setDevice()">{{$l('settings/weather/SetDevice')}}</el-button>
        </el-form-item>
        <el-row v-if="getScreenSize > 1 || delayedLoading[3]">
            <el-collapse accordion>
                <el-collapse-item :title="$l('settings/weather/values')">
                    <el-row>
                        <el-col v-for="(item,i) in getSettingsWeather.valsel" v-bind:key="item.name" :md="12" :lg="8">
                            <el-form-item class="el-form-item-full" :label="item.name">
                                <el-color-picker v-model="getUnsavedLocalSettings.interface.colorsweath[i]"></el-color-picker> 
                                <el-switch class="switch-align" on-text="" off-text="" v-model="item.enabled"></el-switch>
                            </el-form-item></el-col>
                    </el-row>
                </el-collapse-item>
            </el-collapse>
        </el-row>
        
    </el-form>
    
</template>

<style>
.switch-align{
    margin-left:14px;
    margin-bottom:12px;
}
</style>

<script>
import {mapGetters} from 'vuex'
import {setWeather, saveLocalSettings, saveSettings, getSettings} from '@/store/actions'
import {demutateSettings} from '@/common/utils';
export default {
    data() {
        return {
            setDeviceLoading: false,
            delayedLoading:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0},
        }
    },
    computed:{
        ...mapGetters([
            'getSettings',
            'getSettingsWeather',
            'getSettingsInterface',
            'getUnsavedLocalSettings',
            'getScreenSize'
        ])
    },
    methods: {
        onSubmit() {
            console.log('submit!');
        },
        setDevice(){
            this.setDeviceLoading = true;
            //save
            /*
                gumb sproži akcijo save settings in ponovno get settings. 
                Če je bila vmes spremenjena vremenska postaja bo get settings že vrnil nove vrednosti
            */
            //api/set-weather
            setTimeout(()=>{
                this.saveSettings()
                    .then(()=>{
                        debugger;
                        return getSettings(this.$store)
                    })
                    .then(()=>{
                        setWeather(this.$store);
                        this.setDeviceLoading = false;
                    });
            },1500)
        },
        saveSettings(){
            saveLocalSettings(this.$store, this.$localStorage, this.getUnsavedLocalSettings);
            var settings = demutateSettings(this.getSettings);
            return saveSettings(this.$store, settings);
        }
        
    },
    mounted: function(){
        setTimeout(()=>{
            var counter = 0;
            var delayedLoadingInterval = setInterval(()=>{
                this.delayedLoading[counter] = true;
                counter++;
                if(counter > 7) 
                    clearInterval(delayedLoadingInterval);
            },0);
        },500)
    }
}
</script>


// WEBPACK FOOTER //
// Weather.vue?26811c6f